import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PtaSousActivite } from 'src/app/shared/models/ptasousactivite';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-ordonnancement',
  templateUrl: './ordonnancement.component.html',
  styleUrl: './ordonnancement.component.scss'
})

export class OrdonnancementComponent {


  submitted: boolean;

  actionData: any = [];
  modalRef: NgbModalRef | null = null;
  item: any = {};
  itemToDelete!: any;
  @ViewChild('ordonnancementModal') modalContent!: TemplateRef<any>;
  @ViewChild('ordonnancementModalDetail') modalContent1!: TemplateRef<any>;
  items: PtaSousActivite[] = [];
  itemNonOrdonancer: any;
  projetId: any;
  isLoading: boolean = false;
  selectedDirection: any ;


  paginatedItems: PtaSousActivite[] = [];

  firstOrdonnancement = 0;
  rowsOrdonnancement = 10;
  paginatedOrdonnancement: PtaSousActivite[] = [];
  totalRecords: number = 0; // Nombre total d'éléments
  itemsListCopy: any[] = [];

  firstNonOrdonnanceemnt = 0;
  rowsNonOrdonnancement = 10;
  paginateNonOrdonnancement = [];
  totalRecords2: number = 0; // Nombre total d'éléments
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any;

  ExerciceItems: any = [];
  projetItems: any = [];
  annee: any;
  selectedProjet: any;
  directionId: any;
  sousActiviteItem: PtaSousActivite = new PtaSousActivite();
  ordonnancements: any = [];


  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxservice: NgxUiLoaderService
  ) { }

  ngOnInit(): void {

    this.projetId = this.localstorage.getProjetToUser();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    this.userInfo = this.localstorage.getInfoUserToService();

    if (this.userInfo?.data?.groupe === "admin") {
      this.showFiltre = true;
      this.getDirection();
      this.getProjetsList();
    }
    if (this.userInfo?.data?.groupe === "point_focal") {

      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;

      this.getProjetByDirection(this.directionId);
    }
    if (this.userInfo?.data?.groupe !== "admin" && this.userInfo?.data?.groupe !== "point_focal") {
      this.getProjetsList();
    }
    this.getTacheOrdonnacementNon();
    this.calculateReste();
  }//end 


  getProjetsList() {
    this.paramservice.getListUserProjects(this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
        ////console.log(this.projetItems);
      },
      (error) => {
      }
    )
  }//end getProjetsList

  getDirectionByProjet(reference: any) {
    this.paramservice.getDirectionsByProjet(reference).subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error: any) => {
      }
    )
  }//end getProjetByDirection

  processSelectedProjet() {
    //get sous activites associated
    this.getTacheOrdonnacementNon();

    //get direction associated
    if (this.selectedProjet) {
      this.getDirectionByProjet(this.selectedProjet);
    }
  }
  getOrdonnancement(item: any) {
    this.isLoading = true;
    this.ngxservice.start();
    this.paramservice.getOrdonnancement(item).subscribe(
      (response: any) => {
        this.items = response.data;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.ngxservice.stop();
        this.isLoading = false;
        this.updatePaginatedOrdonnancement();
      },
      (error) => {
        this.ngxservice.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "une erreur est survenu lors de la recuperation de la liste des ordonnancements", life: 3000 });
      }
    );
  }

  getNonOrdonnancement(item: any) {
    this.isLoading = true;

    this.paramservice.getNonOrdonnancement(item).subscribe(

      (response: any) => {
        this.ngxservice.stop()

        this.isLoading = false;
        this.itemNonOrdonancer = response.data;
        this.paginateNonOrdonnancement = this.itemNonOrdonancer;
        this.totalRecords2 = this.itemNonOrdonancer.length
        this.updatePaginatedNonOrdonnancement()
      },
      (error) => {
        this.ngxservice.stop()
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "une erreur est survenu lors de la recuperation de la liste des ordonnancements", life: 3000 });
      }
    );
  }



  openModal(sousActivite: PtaSousActivite) {
    if (sousActivite instanceof PtaSousActivite) {
      this.sousActiviteItem = sousActivite;
    } else {
      this.sousActiviteItem = Object.assign(new PtaSousActivite(), sousActivite);
    }

    this.calculateReste();
    // this.sousActiviteItem.reste = (Number(this.sousActiviteItem.total_engage) ?? 0) - (Number(this.sousActiviteItem.total_ordonnance) ?? 0) - (Number(this.sousActiviteItem.total_a_ordonnancer) ?? 0);

    //console.log(this.sousActiviteItem.reste);

    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }//end openModal

  fileName: any;

  onFileSelected(event: any) {
    const file = event.target.files[0];

    console.log("Fichier sélectionné:", file); // 🔥

    if (file) {
      this.fileName = file.name;
      this.sousActiviteItem.preuve = file;
    }
  }
  //enregistrement ordonnancement
  saveOrdonnancement() {

    if (!this.sousActiviteItem.canOrdonnance()) {
      this.messageService.add({ severity: 'info', summary: 'X-Project', detail: this.sousActiviteItem.getErrorMessage() });
      return;
    }

    if (this.sousActiviteItem.total_engage < (this.sousActiviteItem.total_ordonnance + this.sousActiviteItem.total_a_ordonnancer)) {
      this.messageService.add({ severity: 'info', summary: 'X-Project', detail: "Le montant ordonnancé ne peut pas dépasser le montant engagé." });
      return;
    }

    else {

      const formData = new FormData();

      formData.append('total_engage', this.sousActiviteItem.total_engage)
      formData.append('total_ordonnance', this.sousActiviteItem.total_ordonnance)
      formData.append('date_ordonnance', this.sousActiviteItem.date_ordonnance)
      formData.append('total_a_ordonnancer', this.sousActiviteItem.total_a_ordonnancer)
      formData.append('reference', this.sousActiviteItem.reference)
      formData.append('no_mandat', this.sousActiviteItem.no_mandat || "null")
      formData.append('observations', this.sousActiviteItem.observations)

      if (this.sousActiviteItem.preuve) {
        formData.append('lien_mandat', this.sousActiviteItem.preuve)
      }


      this.ngxservice.start();
      this.paramservice.saveActiviteOrdonnacement(formData).subscribe(
        (response: any) => {

          this.messageService.add({ severity: 'success', summary: 'X-Project', detail: response.message });
          this.ngxservice.stop();
          this.getTacheOrdonnacementNon()
          this.modalService.dismissAll();
        },
        (error) => {
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: 'X-Project', detail: error });
          this.ngxservice.stop();
        }
      )
    }
  }//end saveOrdonnancement


  //calcul reste
  calculateReste() {
    const totalEngage = Number(this.sousActiviteItem.total_engage) || 0;
    const totalOrdonnance = Number(this.sousActiviteItem.total_ordonnance) || 0;
    const totalAOrdonnancer = Number(this.sousActiviteItem.total_a_ordonnancer) || 0;

    this.sousActiviteItem.reste =
      totalEngage - totalOrdonnance - totalAOrdonnancer;

    console.log(this.sousActiviteItem.reste);
  }
  updatePaginatedOrdonnancement() {
    const start = this.firstOrdonnancement;
    const end = start + this.rowsOrdonnancement;
    this.paginatedOrdonnancement = this.items.slice(start, end);
  }

  // Méthode pour mettre à jour les données paginées des activités
  updatePaginatedNonOrdonnancement() {
    const start = this.firstNonOrdonnanceemnt;
    const end = start + this.rowsNonOrdonnancement;
    this.paginateNonOrdonnancement = this.itemNonOrdonancer.slice(start, end);
  }


  onPageChangeOrdonnacnement(event: any) {
    this.firstOrdonnancement = event.first
    this.rowsOrdonnancement = event.rows
    this.updatePaginatedOrdonnancement();
  }

  onPageChangeNonOrdonnanement(event: any) {
    this.firstNonOrdonnanceemnt = event.first
    this.rowsNonOrdonnancement = event.rows
    this.updatePaginatedNonOrdonnancement();
  }


  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error) => {
      }
    )
  }

  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
      },
      (error: any) => {
      }
    )
  }

  getTacheOrdonnacementNon() {
    this.ngxservice.start()
    const request = {
      user_ref: this.userInfo?.data?.reference,
      programme_id: this.selectedProjet || null,
      annee: this.annee,
      direction_id: this.selectedDirection || this.directionId || null,

    };

    this.getOrdonnancement(request);
    this.getNonOrdonnancement(request);
  }

  filterDataByDirections() {
    this.getTacheOrdonnacementNon();
  }//en filterDataByDirections


  //annuler ordonnancement
  cancelOrdonnancement(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir annuler cet ordonnancement ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxservice.start();
        this.paramservice.annulationOrdonnancement(event.reference).subscribe(
          (response: any) => {
            this.ngxservice.stop();
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: 'L\'engagement a été annulé' });
            this.getTacheOrdonnacementNon();
            this.loadOrdonnancements(this.activiteId)
          },
          (error: any) => {

            console.log("log d'erreur", error);

            this.ngxservice.stop();
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message || "une erreur est survenu", life: 3000 });
          },
        )
      },
    });
  }//end cancelOrdonnancement
  isLoadingOrdonnancement: boolean = false

  exportToDocument(item: any) {

    if (!item) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attention',
        detail: 'Aucun élément sélectionné'
      });
      return;
    }


    this.ngxservice.start();

    this.paramservice.downloadFicheOrdonnancement(item.reference).subscribe(
      (response: Blob) => {

        //  définir extension dynamique
        const extension = 'pdf';
        const filename = `ordonnancement.${extension}`;

        // téléchargement
        FileSaver.saveAs(response, filename);

        // ouverture auto seulement pour PDF
        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxservice.stop();

        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: `Fichier ${extension.toUpperCase()} téléchargé`,
          life: 3000
        });

      },
      (error: any) => {
        this.ngxservice.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }



  activiteId: any;

  openModalHistoriqueOrdonnacement(item: any) {
    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });

    this.activiteId = item;
    this.loadOrdonnancements(item);
  }//end openModal


  loadOrdonnancements(engagementRef: any) {
    this.isLoadingOrdonnancement = true;

    this.paramservice.getHistoriqueOrdonnacement(engagementRef.id).subscribe(
      (res: any) => {
        this.ordonnancements = res.data || [];
        this.isLoadingOrdonnancement = false;
      },
      (error) => {
        this.isLoadingOrdonnancement = false;
        this.ordonnancements = [];
      }
    );
  }


}
